import React from 'react';

const ProgressBarLoader = ({ progress, text }) => {
  return (
    <>
      <div className="progress-bar-loader">
        <div className="progress-text">{text}</div>
        <div className="progress-container">
          <div 
            className="progress-bar" 
            style={{ width: `${progress}%` }}
          />
        </div>
        <div className="progress-percentage">{progress}%</div>
      </div>
      
      <style jsx>{`
        .progress-bar-loader {
          width: 100%;
          max-width: 400px;
          padding: 25px;
          background: rgba(255, 255, 255, 0.95);
          border-radius: 16px;
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
          backdrop-filter: blur(8px);
          animation: slideIn 0.3s ease-out;
        }

        .progress-text {
          font-size: 16px;
          color: #2c3e50;
          margin-bottom: 15px;
          text-align: center;
          font-weight: 500;
          animation: fadeIn 0.5s ease-out;
        }

        .progress-container {
          width: 100%;
          height: 16px;
          background: #f0f2f5;
          border-radius: 8px;
          overflow: hidden;
          margin-bottom: 8px;
          position: relative;
          box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1);
        }

        .progress-bar {
          height: 100%;
          background: linear-gradient(90deg, #7a6ad8, #5e4db3);
          border-radius: 8px;
          transition: width 0.3s ease-in-out;
          position: relative;
          overflow: hidden;
        }

        .progress-bar::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(
            90deg,
            rgba(255, 255, 255, 0) 0%,
            rgba(255, 255, 255, 0.4) 50%,
            rgba(255, 255, 255, 0) 100%
          );
          animation: shimmer 1.5s infinite;
          transform: translateX(-100%);
        }

        .progress-bar::after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(
            90deg,
            rgba(255, 255, 255, 0) 0%,
            rgba(255, 255, 255, 0.2) 50%,
            rgba(255, 255, 255, 0) 100%
          );
          animation: pulse 2s infinite;
        }

        .progress-percentage {
          font-size: 14px;
          color: #7a6ad8;
          text-align: right;
          font-weight: 600;
          animation: fadeIn 0.5s ease-out;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          gap: 5px;
        }

        .progress-percentage::after {
          content: '';
          width: 8px;
          height: 8px;
          background: #7a6ad8;
          border-radius: 50%;
          animation: pulse 1s infinite;
        }

        @keyframes shimmer {
          0% {
            transform: translateX(-100%);
          }
          100% {
            transform: translateX(100%);
          }
        }

        @keyframes pulse {
          0% {
            opacity: 0.6;
          }
          50% {
            opacity: 1;
          }
          100% {
            opacity: 0.6;
          }
        }

        @keyframes slideIn {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        /* RTL Support */
        [dir="rtl"] .progress-bar-loader {
          text-align: right;
        }

        [dir="rtl"] .progress-percentage {
          text-align: left;
          flex-direction: row-reverse;
        }

        /* Responsive Design */
        @media (max-width: 480px) {
          .progress-bar-loader {
            padding: 20px;
            max-width: 100%;
          }

          .progress-text {
            font-size: 14px;
          }

          .progress-percentage {
            font-size: 12px;
          }
        }
      `}</style>
    </>
  );
};

export default ProgressBarLoader; 